import styled from '@emotion/styled';
import { motion } from 'framer-motion';

const PageContainer = styled.div`
  min-height: 100vh;
  background: #121212;
  color: white;
  padding-top: 80px;
`;

const ContentContainer = styled.div`
  max-width: 1400px;
  margin: 0 auto;
  padding: 2rem;
`;

const ProductVideo = styled(motion.video)`
  width: 100%;
  max-height: 80vh;
  object-fit: contain;
  filter: drop-shadow(0 10px 20px rgba(0,0,0,0.3));
  border-radius: 4px;
`;

const MotionPro = () => {
  return (
    <PageContainer>
      <ContentContainer>
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 style={{ textAlign: 'center' }}>Coming soon...</h1>
          <br/>
          <ProductVideo
            autoPlay
            loop
            muted
            playsInline
            whileHover={{ scale: 1.02 }}
            transition={{ duration: 0.3 }}
          >
            <source src="/assets/rsr-motionpro.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </ProductVideo>
        </motion.div>
      </ContentContainer>
    </PageContainer>
  );
};

export default MotionPro;
